import React from 'react'
import {CButton, CForm, CFormInput} from "@coreui/react";
import CustomPagination from "../../components/CustomPagination";
import ManageTransferOrdersTable from "./ManageTransferOrdersTable";
import {Link} from "react-router-dom";


const ManageTransferOrders = () => {
  return (
    <div>
      <ManageTransferOrdersTable/>
    </div>
  );
}

export default ManageTransferOrders;
